<div class="breadcrumbs">
    <span class="title">Gestione Emergenze <mat-icon style="vertical-align: middle;">
            keyboard_arrow_right</mat-icon> Elenco Interventi </span>
</div>
<hr>

<div class="titolo flex-display ">
    <div class="flex-display">
        <button mat-stroked-button class="pers" (click)="onNavigate('back')">
            <mat-icon style="vertical-align: middle;">keyboard_arrow_left</mat-icon>
        </button>

        <span class="h1 upp">Elenco Interventi </span>
    </div>
    <div *ngIf="!isDettaglio" class="flex-row">
        <button mat-flat-button color='accent' class="pers3 mleft" (click)="openChangeStatointerventoDialog()">
            ESEGUI
        </button>
    </div>
</div>

<div class="flex-row-select" *ngIf="!isDettaglio">
    <button mat-flat-button color='accent' class="pers3-select" (click)="showSelect()">
        SELEZIONA OPERAZIONE
    </button>
    <span *ngIf="this.select" [formGroup]="form">
        <mat-form-field appearance="fill" color='accent' class='searchbar operSel'>
            <mat-select [formControlName]="'operazione'">
                <mat-option></mat-option>
                <mat-option *ngFor="let operazione of operazioni" value="{{operazione.idOperazione}}">
                    <span>{{ operazione.descOperazione }}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </span>
</div>

<mat-expansion-panel class='rett' hideToggle (opened)="arrowFlag = !arrowFlag" (closed)='arrowFlag = !arrowFlag'>
    <mat-expansion-panel-header class="colorSearch">
        <mat-panel-title class='search'>
            <mat-icon>search</mat-icon>
            <strong class="title">CERCA</strong>
            <mat-icon *ngIf="arrowFlag">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="!arrowFlag">keyboard_arrow_down</mat-icon>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="coloredS" [formGroup]="form">

        <div class="flex-row">

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label for="codice intervento">Codice intervento</mat-label>
                <input matInput [formControlName]="'codiceIntervento'">
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>DPGR</mat-label>
                <input matInput [formControlName]="'dpgr'">
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Stato</mat-label>
                <mat-select [formControlName]="'stato'">
                    <mat-option value=''></mat-option>
                    <mat-option value="ATTFIN">In attesa di finanziamento</mat-option>
                    <mat-option value="PRERES">Preventivamente respinto</mat-option>
                    <mat-option value="IDONEO"> Idoneo</mat-option>
                    <mat-option value="PROFIN">In proposta di finanziamento</mat-option>
                    <mat-option value="RESPIN">Respinto</mat-option>
                    <mat-option value="FINANZ">Finanziato</mat-option>
                    <mat-option value="ESPUNT">Espunto</mat-option>
                    <!-- <mat-option value="ATTLIQ">In attesa di liquidazione</mat-option> -->
                    <!-- <mat-option value="LIQUID">Liquidato</mat-option> -->
                </mat-select>
            </mat-form-field>


        </div>


        <div class="flex-row">

            <!-- <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Ente</mat-label>
                <mat-select [formControlName]="'idEnte'">
                    <mat-option value=''></mat-option>
                </mat-select>
            </mat-form-field> -->

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Ente</mat-label>
                <input type="text" matInput [formControlName]="'idEnte'" (click)="refreshForm()"
                    [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option (click)="sendEnte(ente)" *ngFor="let ente of filteredEnti | async"
                        [value]="ente.descrizione" style="font-size: 12px;">
                        {{ente.descrizione}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Descrizione intervento</mat-label>
                <textarea [formControlName]="'descrIntervento'" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"></textarea>
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Stato attivazione intervento</mat-label>
                <mat-select [formControlName]="'idStatoEsecuzione'">
                    <mat-option value=''></mat-option>
                    <mat-option value=1>In corso di progettazione</mat-option>
                    <mat-option value=2>Progetto approvato</mat-option>
                    <mat-option value=3>In corso gara d'appalto</mat-option>
                    <mat-option value=4>In corso di affidamento</mat-option>
                    <mat-option value=5>Lavori affidati (aggiudicazione efficacie)</mat-option>
                    <mat-option value=6>Lavori consegnati</mat-option>
                    <mat-option value=7>Lavori in corso di di esecuzione</mat-option>
                    <mat-option value=8>Lavori conclusi</mat-option>
                    <mat-option value=9>In corso di collaudo</mat-option>
                    <mat-option value=10>In corso di rendicontazione finale</mat-option>
                </mat-select>
            </mat-form-field>

        </div>

        <div class="flex-row">

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Località</mat-label>
                <input [formControlName]="'localita'" matInput>
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Ente attuatore</mat-label>
                <input [formControlName]="'enteAttuatore'" matInput>
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Classe di priorità</mat-label>
                <mat-select [formControlName]="'idPriorita'">
                    <mat-option value=''></mat-option>
                    <mat-option *ngFor="let p of priorita" value="{{p.idPriorita}}">
                        {{ p.descrizionePriorita | capitalize}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="flex-row">

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Importo complessivo richiesto da</mat-label>
                <input [formControlName]="'importoComplRichiestoDa'" type="number" matInput>
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Importo complessivo richiesto a</mat-label>
                <input [formControlName]="'importoComplRichiestoA'" type="number" matInput>
            </mat-form-field>

            <mat-form-field appearance="legacy" color='accent' class="searchbar hidden">
                <input hidden matInput>
            </mat-form-field>
        </div>

        <div class="flex-row">

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Importo spese sostenute da</mat-label>
                <input [formControlName]="'importoSpeseSostenuteDa'" type="number" matInput>
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Importo spese sostenute a</mat-label>
                <input [formControlName]="'importoSpeseSostenuteA'" type="number" matInput>
            </mat-form-field>

            <mat-form-field appearance="legacy" color='accent' class="searchbar hidden">
                <input hidden matInput>
            </mat-form-field>

        </div>

        <div class="flex-row">

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Data inizio lavori da:</mat-label>
                <input matInput [matDatepicker]="picker1" [formControlName]="'dataInizioLavoriDa'" class='searchbar'>
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Data inizio lavori a:</mat-label>
                <input matInput [matDatepicker]="picker2" [formControlName]="'dataInizioLavoriA'" class='searchbar'>
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="legacy" color='accent' class="searchbar hidden">
                <input hidden matInput>
            </mat-form-field>

        </div>

        <div class="flex-row">

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Data fine lavori da:</mat-label>
                <input matInput [matDatepicker]="picker3" [formControlName]="'dataFineLavoriDa'" class='searchbar'>
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Data fine lavori a:</mat-label>
                <input matInput [matDatepicker]="picker4" [formControlName]="'dataFineLavoriA'" class='searchbar'>
                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                <mat-datepicker #picker4></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="legacy" color='accent' class="searchbar hidden">
                <input hidden matInput>
            </mat-form-field>

        </div>


    </div>
    <mat-action-row class='colored'>
        <button mat-stroked-button class="pers2" color="warn">Esporta in CSV</button>
        <button mat-stroked-button class="pers2" color="warn" (click)="onReset()">Reset</button>
        <button mat-raised-button class="pers2" color="accent" (click)="ricercaListaInterventi(true)">Cerca</button>
    </mat-action-row>
</mat-expansion-panel>

<mat-table [dataSource]="dataSource" matSort matSortActive="codiceIntervento" matSortDirection="desc"
    matSortDisableClear>

    <ng-container matColumnDef="operazione">
        <mat-header-cell *matHeaderCellDef>
            <mat-checkbox class="example-margin" [checked]="operazioneSuTutti==='S'?true : false"
                (change)="setAll($event.checked)"></mat-checkbox>
        </mat-header-cell>
        <mat-cell [attr.data-label]="'OPERAZIONE'" *matCellDef="let element">
            <mat-checkbox class="example-margin" (change)="sendIntervento(element)"
                [checked]="element.aggiunto===true?true:false"></mat-checkbox>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="codiceIntervento">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Codice Intervento </mat-header-cell>
        <mat-cell [attr.data-label]="'CODICEINTERVENTO'" *matCellDef="let element"> {{ element.codIntervento }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="stato">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Stato </mat-header-cell>
        <mat-cell [attr.data-label]="'STATO'" *matCellDef="let element">
            <span *ngIf="element.stato == 'ATTFIN'">In attesa di finanziamento</span>
            <span *ngIf="element.stato == 'PRERES'">Preventivamente respinto</span>
            <span *ngIf="element.stato == 'IDONEO'"> Idoneo</span>
            <span *ngIf="element.stato == 'PROFIN'">In proposta di finanziamento</span>
            <span *ngIf="element.stato == 'RESPIN'">Respinto</span>
            <span *ngIf="element.stato == 'FINANZ'">Finanziato</span>
            <span *ngIf="element.stato == 'ESPUNT'">Espunto</span>
            <!-- <span *ngIf="element.stato == 'ATTLIQ'">In attesa di liquidazione</span> -->
            <!-- <span *ngIf="element.stato == 'LIQUID'">Liquidato</span> -->
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="ente">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Ente </mat-header-cell>
        <mat-cell [attr.data-label]="'ENTE'" *matCellDef="let element">
            {{element.descrizioneEnte}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="descrIntervento">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Descrizione intervento </mat-header-cell>
        <mat-cell [matTooltip]="element.descrizIntervento" [matTooltipPosition]="'above'"
            [matTooltipClass]="'tooltip-class-a-capo'" [attr.data-label]="'DESCRIZIONEINTERVENTO'" *matCellDef="let element">
        <p class="descInt">
            {{element.descrizIntervento}}
        </p>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="importo">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Importo complessivo </mat-header-cell>
        <mat-cell [attr.data-label]="'IMPORTO'" *matCellDef="let element"> {{
            replaceDotWithComma(element.importoComplRichiesto) }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="statoAttuazione">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Stato attivazione intervento </mat-header-cell>
        <mat-cell [attr.data-label]="'STATOATTIVAZIONEINTERVENTO'" *matCellDef="let element">
            {{element.statoAttuazioneProgetto}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
        <mat-header-cell [ngClass]="'customWidthClass'" *matHeaderCellDef></mat-header-cell>
        <mat-cell [ngClass]="'customWidthClass'" *matCellDef="let element">
            <span *ngIf="element.idIntervento !== openToggle" class="material-icons tool" title="apri/chiudi toolbar"
                (click)="openToggle = element.idIntervento">more_horiz</span>
            <myp-toolbar *ngIf="element.idIntervento === openToggle" [toolbar]="generateToolBar(element.statoEvento)"
                role=toolbar [data]="element" (onToolbarEvent)="handleToolbarEvent($event)"></myp-toolbar>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

</mat-table>

<div *ngIf="this.dataSource.counter$.source['value'] === 0">
    <mat-card class="emptyTable">
        <mat-card-content>
            <h6>Non ci sono risultati</h6>
        </mat-card-content>
    </mat-card>
</div>

<mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="this.risultatiPerPagina"
    [pageSizeOptions]="[3, 5, 10, 300]"></mat-paginator>